<template>
    <ul class="grid grid-cols-1 gap-6">
        <template v-for="(result, index) in results" :key="index">
            <li
                class=""
            >
                <SearchResult
                    :result="result"
                    :additional-data="
                        additionalData[result.Artikelnr.raw] ?? null
                    "
                />
            </li>
        </template>
    </ul>
</template>

<script>
import SearchResult from "./search-result.vue";

export default {
    inject: ["productsSvc", "cartSvc"],
    components: {
        SearchResult,
    },
    props: {
        results: {
            type: Array,
            required: true,
        },
        filterAvailability: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            isLoggedIn: this.cartSvc.isUserLoggedIn(),
            additionalData: {},
        };
    },
    watch: {
        results(newResults) {
            this.getItemInfos(newResults);
        },
    },
    mounted() {
        this.getItemInfos(this.results);
    },
    methods: {
        getItemInfos(results) {
            let articleNumbers = results.map((result) => result.Artikelnr.raw);

            this.productsSvc
                .getMultipleItemInfos(articleNumbers)
                .then((info) => {
                    this.additionalData = info;
                });
        },
    },
};
</script>

<style>
.search-section__search-results {
    display: flex;
    flex-wrap: wrap;
}

.search-section__search-result {
    width: 48%;
    margin: 1%;
    background: white;
}
</style>
